import { createContext, useContext } from 'react';
import { useActor } from '@xstate/react';
export const Context = createContext(undefined);
export const { Provider: AutopayBannerProvider } = Context;
const useAutopayBannerMachine = () => {
    const actorRef = useContext(Context);
    return useActor(actorRef);
};
export default useAutopayBannerMachine;
